function cov_1rel6h4whw() {
  var path = "/app/src/components/long-term-content/components/installment-item-skeleton/index.ts";
  var hash = "193bd5c16740f364ae34a268c37dfc5ec1c47257";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/installment-item-skeleton/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "193bd5c16740f364ae34a268c37dfc5ec1c47257"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1rel6h4whw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1rel6h4whw();
export { InstallmentItemSkeleton } from './installment-item-skeleton';